<div class="fe-corridor-systems-container">
  <div class="table-actions-bar">
    <div class="table-title">FE Corridor Systems</div>
    <div class="button-group">
      <button (click)="clearSelection()" [disabled]="!canClearSelection()">
        Clear Selection
      </button>
      <button (click)="clearAllFilters()" [disabled]="!hasActiveFilters()">
        Clear All Filters
      </button>
      <button (click)="cancelEdit()" *ngIf="hasNewRows">Cancel</button>
      <button (click)="addNewRow()" [disabled]="isLoading">New</button>
      <button (click)="saveRows()" [disabled]="!corridorSystems.length || isSaving || isLoading">
        <span *ngIf="isSaving" class="spinner-icon"></span>
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
      <button (click)="deleteSelectedCorridors()" [disabled]="!selectedRows.length || isSaving || isLoading">
        Delete
      </button>
      <button (click)="openExportDialog()" [disabled]="!corridorSystems.length || isSaving || isLoading">
        Export
      </button>
    </div>
  </div>

  <!-- Loading Spinner using FE Capacities structure -->
  <div class="spinner-container" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>

  <!-- Save Loading Spinner Overlay -->
  <div class="loading-overlay" *ngIf="isSaving">
    <div class="spinner-container">
      <div class="spinner"></div>
      <p>Saving corridor systems...</p>
    </div>
  </div>

  <!-- Table Content - Show when not loading initially -->
  <div class="table-container" *ngIf="!isLoading">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-select">Select</div>
        <div class="table-header-cell">
          <div class="col-wrap">
            <div class="text-wrap">Development Area(s)</div>
            <div class="filter-icon-container">
              <img class="filter-icon" [ngClass]="{ 'active-filter': isFilterActive('developmentArea') }" src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                (click)="openFloatingFilter($event, 'developmentArea')" title="Filter Development Area" />
            </div>
          </div>
        </div>
        <div class="table-header-cell">
          <div class="col-wrap">
            <div class="text-wrap">Facility Type</div>
            <div class="filter-icon-container">
              <img class="filter-icon" [ngClass]="{ 'active-filter': isFilterActive('facilityType') }" src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                (click)="openFloatingFilter($event, 'facilityType')" title="Filter Facility Type" />
            </div>
          </div>
        </div>
        <div class="table-header-cell">
          <div class="col-wrap">
            <div class="text-wrap">Facilities Contained in Node</div>
            <div class="filter-icon-container">
              <img class="filter-icon" [ngClass]="{ 'active-filter': isFilterActive('facilitiesContained') }" src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                (click)="openFloatingFilter($event, 'facilitiesContained')" title="Filter Facilities Contained" />
            </div>
          </div>
        </div>
        <div class="table-header-cell">
          <div class="col-wrap">
            <div class="text-wrap">Pseudo Facility Name</div>
            <div class="filter-icon-container">
              <img class="filter-icon" [ngClass]="{ 'active-filter': isFilterActive('pseudoFacilityName') }" src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                (click)="openFloatingFilter($event, 'pseudoFacilityName')" title="Filter Pseudo Facility Name" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <div class="table-body-row" *ngFor="let system of getOrderedData(); let i = index">
        <!-- Select Checkbox -->
        <div class="table-body-cell fixed-width-cell-select">
          <input type="checkbox" [checked]="selectedRows.includes(system)"
            (change)="toggleRowSelection(system, $event)" />
        </div>

        <!-- Development Area Dropdown - Editable only for new rows -->
        <div class="table-body-cell">
          <div class="cell-wrapper">
            <select *ngIf="system.isNew; else developmentAreaReadOnly" [(ngModel)]="system.developmentArea" class="form-select"
              (focus)="markAsEdited(system)" (change)="onDevelopmentAreaChange(system)">
              <option value="">Select Development Area</option>
              <option *ngFor="let area of developmentAreas" [value]="area">
                {{ area }}
              </option>
            </select>
            <ng-template #developmentAreaReadOnly>
              <input type="text" [value]="system.developmentArea" class="form-input readonly-field" readonly />
            </ng-template>
          </div>
        </div>

        <!-- Facility Type - Read-only, automatically set to CS -->
        <div class="table-body-cell">
          <div class="cell-wrapper">
            <input type="text" [value]="system.facilityType" class="form-input readonly-field" readonly
              placeholder="CS" />
          </div>
        </div>

        <!-- Facilities Contained Multi-Select - Cascaded with Dev Area -->
        <div class="table-body-cell">
          <div class="multi-facility-field">
            <div class="facility-tags">
              <span *ngFor="let facility of system.facilitiesContained" class="facility-chip">
                {{ facility }}
                <span class="remove-chip" (click)="removeFacility(system, facility)">×</span>
              </span>
              <select class="facility-select" (focus)="onFacilitiesDropdownFocus(system)" (change)="addFacility(system, $event)"
                [disabled]="!system.developmentArea">
                <option value="" disabled selected hidden>
                  {{
                  !system.developmentArea
                  ? "Select Dev Area first"
                  : "Select Facility"
                  }}
                </option>
                <option *ngFor="
                    let facility of getFacilitiesForDevArea(
                      system.developmentArea
                    )
                  " [value]="facility" [disabled]="system.facilitiesContained.includes(facility)">
                  {{ facility }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Pseudo Facility Name Text Input - user entered -->
        <div class="table-body-cell">
          <div class="cell-wrapper">
            <input type="text" [(ngModel)]="system.pseudoFacilityName" class="form-input" (focus)="markAsEdited(system)"
              (change)="markAsEdited(system)" placeholder="Enter pseudo facility name" title="Enter pseudo facility name manually" style="width: 100%; min-width: 200px" />
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div *ngIf="getOrderedData().length === 0" class="empty-state">
        No corridor systems data available. Click "New" to get started.
      </div>
    </div>
  </div>
</div>

<!-- Floating Filter Box -->
<div class="floating-filter-dropdown" *ngIf="showFloatingFilter" [ngStyle]="{
    top: dropdownPosition.top + 'px',
    left: dropdownPosition.left + 'px'
  }">
  <input type="text" [(ngModel)]="filterSearch[activeFilter]" placeholder="Search..." />
  <div class="filter-options">
    <label *ngFor="let option of getFilterOptions(activeFilter)">
      <input type="checkbox" [checked]="isChecked(activeFilter, option)"
        (change)="toggleMultiFilter(activeFilter, option, $event)" />
      <span>{{ option }}</span>
    </label>
  </div>
  <div class="filter-buttons">
    <button (click)="applyFilter(activeFilter)">Apply</button>
    <button (click)="clearFilter(activeFilter)">Clear</button>
  </div>
</div>

<!-- Delete confirmation dialog template -->
<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export FE Corridor Systems</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>